import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from 'react-redux';
import { apiSlice } from "../data/api/api";
import articlesSlice from "../data/slices/articles-slice";
import filterTextSlice from '../data/slices/filter-text-slice';
import filtersSlice from '../data/slices/filters-slice';

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        articles: articlesSlice,
        filterText: filterTextSlice.reducer,
        filters: filtersSlice
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat([
            apiSlice.middleware
        ]);
    }
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;